module.exports = __webpack_public_path__ + "img/slide-9.309c9bb8.jpg";